export default "__VITE_ASSET__6492b87c__"